import { AuthContext, initialAuthState, createState } from "./CognitoAuthContext";
import { useCallback, useEffect, useState } from "react";
import { CognitoIdentityService } from "./CognitoIdentityService.js";

export const AuthProvider = ({ children }) => {
  const [initialised, setInitialised] = useState(false);
  const [authService, setAuthService] = useState(null);
  const [state, setState] = useState(initialAuthState);

  // Initialize the CognitoIdentityService
  useEffect(() => {
    // Use environment variables for Cognito configuration
    const cognitoConfig = {
      userPoolId: import.meta.env.VITE_COGNITO_USER_POOL_ID,
      clientId: import.meta.env.VITE_COGNITO_CLIENT_ID,
      autoRefresh: true,
      refreshSlack: 60,
    };

    // Create an auth service
    const service = new CognitoIdentityService(cognitoConfig);

    // Set up session listener to update state when session changes
    service.setSessionListener((updatedSession) => {
      const state = createState(updatedSession);
      setState(state);
    });

    // Set initial session
    const initialSession = service.getSession();
    const state = createState(initialSession);
    setState(state);
    setAuthService(service);

    // Mark as initialised
    setInitialised(true);
    // Clean up on unmount
    return () => {
      if (service) {
        service.cleanup();
      }
      setInitialised(false);
    };
  }, []);

  // Wrappers around auth service allowing us to easily expose these to the front end and perform other actions
  const refresh = useCallback(async () => {
    await authService.refreshAuthorizationToken();
  }, [authService]);

  return (
    <AuthContext.Provider value={{ initialised, authService, refresh, session: state }}>
      {children}
    </AuthContext.Provider>
  );
};
